import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import ProductCard from "../../components/ProductCard";
import CategoryCard from "../../components/CategoryCard";
import { useCart } from "../../hooks/useCart";
import { useToastContext } from "../../context/ToastContext";
import products from "../../data/products";
import categories from "../../data/categories";
import styles from "./HomePage.module.css";

const FEATURED = products.filter(p => p.tags.includes("hot")).slice(0, 4);
const NEW_ARRIVALS = [...products]
  .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
  .slice(0, 4);

function HomePage() {
  const { addItem } = useCart();
  const { addToast } = useToastContext();

  function handleAddToCart(product) {
    addItem(product);
    addToast(`「${product.name}」已加入購物車`, "success");
  }

  return (
    <main className={styles.page}>
      {/* Hero Banner */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <p className={styles.heroEyebrow}>全新上市 · 限時特惠</p>
          <h1 className={styles.heroTitle}>沃克貓購物網<br />一站購齊</h1>
          <p className={styles.heroSub}>精選 3C、服飾、居家、書籍、運動各類商品，品質保證，快速到貨。</p>
          <div className={styles.heroBtns}>
            <Link to="/products" className={styles.heroBtnPrimary}>
              立即選購 <FaArrowRight />
            </Link>
            <Link to="/products?onlySale=true" className={styles.heroBtnSecondary}>
              查看特惠
            </Link>
          </div>
        </div>
        <div className={styles.heroDecor} aria-hidden="true" />
      </section>

      {/* Categories */}
      <section className={styles.section}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>商品分類</h2>
          <div className={styles.categoriesGrid}>
            {categories.map(cat => (
              <CategoryCard key={cat.id} category={cat} />
            ))}
          </div>
        </div>
      </section>

      {/* Hot Products */}
      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>熱銷商品</h2>
            <Link to="/products" className={styles.viewAll}>
              查看全部 <FaArrowRight />
            </Link>
          </div>
          <div className={styles.productsGrid}>
            {FEATURED.map(product => (
              <ProductCard
                key={product.id}
                product={product}
                onAddToCart={handleAddToCart}
              />
            ))}
          </div>
        </div>
      </section>

      {/* New Arrivals */}
      <section className={`${styles.section} ${styles.sectionAlt}`}>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>新品上市</h2>
            <Link to="/products?sort=newest" className={styles.viewAll}>
              查看全部 <FaArrowRight />
            </Link>
          </div>
          <div className={styles.productsGrid}>
            {NEW_ARRIVALS.map(product => (
              <ProductCard
                key={product.id}
                product={product}
                onAddToCart={handleAddToCart}
              />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default HomePage;
